<script lang="ts">
  import { toasts } from "$lib/stores/toasts.svelte";
</script>

<div class="fixed top-4 right-4 z-50 flex flex-col gap-2 w-80 max-w-[90vw]">
  {#each toasts.list as t (t.id)}
    <div role="status"
         class="rounded-lg shadow-lg p-3 border surface flex items-start gap-3"
         class:border-emerald-300={t.kind === "success"}
         class:border-amber-300={t.kind === "warn"}
         class:border-red-300={t.kind === "error"}
         class:border-sky-300={t.kind === "info"}>
      <span class="text-xl leading-none" aria-hidden="true">
        {t.kind === "success" ? "✅" : t.kind === "warn" ? "⚠️" : t.kind === "error" ? "❌" : "ℹ️"}
      </span>
      <div class="flex-1 text-sm">
        <div class="font-semibold">{t.title}</div>
        {#if t.detail}<div class="text-muted text-xs mt-0.5">{t.detail}</div>{/if}
      </div>
      <button class="btn-ghost -m-2" aria-label="Fechar"
              onclick={() => toasts.dismiss(t.id)}>✕</button>
    </div>
  {/each}
</div>
